import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BotTrackingSettings = lazy(() =>
  import("@scenes/EmailSettings/BotTrackingSettings").then((module) => ({
    default: module.BotTrackingSettings,
  }))
);

export const botTrackingSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("bot-tracking-settings-nro-heading", "Bot Filtering"),
  pageNameForTracking: () => "Bot Filtering",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: BotTrackingSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
};
